import { HttpClient } from '@angular/common/http';
import { inject, Injectable, VERSION } from '@angular/core';
import { Observable } from 'rxjs';
import environment from '@environments/environment';

export interface ApiVersionResponse {
  be_build_number: string;
  app_version?: string;
  iris_version?: string;
}

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private readonly http = inject(HttpClient);

  getFeVersion(): string {
    return VERSION.full;
  }

  getApiVersion(): Observable<ApiVersionResponse> {
    return this.http.get<ApiVersionResponse>(
      `${environment.irisApi}/settings/version/`,
    );
  }
}
